module.exports = __webpack_public_path__ + "static/media/2DGACM13.a852f882.jpg";